import styled from '@emotion/styled';
import { Modal } from '@lightspeed/flame/Modal';

export const ConfirmModal = styled(Modal)`
  max-width: 600px;
  width: 600px;
`;

export const StatusModal = styled(Modal)`
  max-width: 350px;
  width: 350px;
`;
